<button class="mobile-faktury-button" (click)="navigateToFaktury($event)">
  <div class="faktury-content">
    <span class="faktury-label">{{ 'akcja.faktury-2-plus-1' | translate }}</span>
  </div>
</button>